// @ts-nocheck
/**
 * Generated by orval v7.4.1 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */

/**
 * Description of the performance levels of a rubric
 */
export interface PerformanceLevelDescriptionOutput {
  /** list of criteria that are met in an excellent performance */
  excellent: unknown;
  /** list of criteria that are met in a good performance */
  good: unknown;
  /** list of criteria that are met in a satisfactory performance */
  satisfactory: unknown;
  /** list of criteria that are met in a performance that needs improvement */
  needsImprovement: unknown;
}
